"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useVideoJSPlayer = require("./useVideoJSPlayer");
Object.keys(_useVideoJSPlayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useVideoJSPlayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useVideoJSPlayer[key];
    }
  });
});